import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createAgentOffice } from 'api/agents';
import { getOffices } from 'api/offices';
import { useParams } from 'react-router-dom';
import Popup from 'components/Popup';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';

export default function AgentAddOfficesPopup({
    visible,
    setVisible,
    present = [],
}) {

    const { agentId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['updateOffice'],
        mutationFn: createAgentOffice,
        onSuccess: () => {
            cache.invalidateQueries(['agents', agentId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating agent-office:", error);
        }
    });

    const { data: offices } = useQuery({
        queryKey: ['offices'],
        queryFn: async () => await getOffices({}),
    });


    const officeOptions = offices?.map(office => {
        return {
            value: office._id,
            label: office.name
        }
    });


    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: agentId,
            data: {
                office: e.target.office.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler}>
                
                {officeOptions &&
                    <SelectInput
                        label="Ufficio"
                        name="office"
                        options={officeOptions?.filter(office => !present.includes(office.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
